import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_TITLE = "E-torneios";

// Static route -> readable PT-BR name
const STATIC_TITLES = {
  "/login": "Login",
  "/register": "Cadastro",
  "/forgot-password": "Recuperar Senha",
  "/dashboard": "Dashboard",
  "/championships": "Campeonatos",
  "/championships/new": "Novo Campeonato",
  "/federations": "Federações",
  "/teams": "Equipes",
  "/athletes": "Atletas",
  "/athletes/new": "Novo Atleta",
  "/weight-categories": "Categorias de Peso",
  "/registrations": "Inscrições",
  "/event-structure": "Estrutura do Evento",
  "/central-desk": "Mesa Central",
  "/medals": "Medalhas",
  "/my-profile": "Meu Perfil",
  "/audit": "Auditoria",
  "/fight-times": "Tempos de Luta",
  "/admin/reset": "Resetar Dados",
  "/admin/users": "Gerenciar Usuários",
  "/public": "Público",
};

// Dynamic route patterns -> readable name
const PATTERN_TITLES = [
  { regex: /^\/championships\/[^/]+\/edit$/, name: "Editar Campeonato" },
  { regex: /^\/championships\/[^/]+$/, name: "Detalhes do Campeonato" },
  { regex: /^\/athletes\/[^/]+\/card$/, name: "Carteirinha do Atleta" },
  { regex: /^\/public\/[^/]+\/athletes$/, name: "Atletas do Campeonato" },
  { regex: /^\/public\/[^/]+\/ranking$/, name: "Ranking do Campeonato" },
  { regex: /^\/public\/[^/]+\/telao$/, name: "Telão" },
  { regex: /^\/public\/[^/]+$/, name: "Resultados Públicos" },
];

function resolveTitle(pathname) {
  if (STATIC_TITLES[pathname]) return STATIC_TITLES[pathname];
  for (const { regex, name } of PATTERN_TITLES) {
    if (regex.test(pathname)) return name;
  }
  return null;
}

export function useDynamicTitle() {
  const location = useLocation();
  useEffect(() => {
    const pageName = resolveTitle(location.pathname);
    document.title = pageName ? `${BASE_TITLE} | ${pageName}` : BASE_TITLE;
  }, [location.pathname]);
}

export default useDynamicTitle;
